export enum BrugerIndstillingTypeKeyEnum {
  // Page: Forloebsoverblik
  PageForloebsoverblikPageSize = 1,
  PageForloebsoverblikViewOption = 2,
  PageForloebsoverblikUseAdvancedSearch = 3,
  PageForloebsoverblikUseUdvidOverlap = 4,
  PageForloebsoverblikUseHorizontalLines = 5,
  PageForloebsoverblikUseUbesatteStillinger = 6,
  PageForloebsoverblikUseForloebKladder = 10,

  PageForloebsoverblikShowAnonymized = 9,
  PageForloebsoverblikShowInactive = 13,

  // Page: Uddannelseslaeger
  PageUddannelseslaegerFilterForloebStatus = 7,

  // Globals
  LatestActiveUserRoleTitle = 8,

  // Page: Kompetencer
  PageKompetencerViewOption = 11,
  PageKompetencerViewWidth = 12,
}

export const castBrugerIndstillingValueToCorrectType = (typeKey: BrugerIndstillingTypeKeyEnum, settingValue: string) => {
  switch (typeKey)
  {
      case BrugerIndstillingTypeKeyEnum.PageForloebsoverblikPageSize:
      case BrugerIndstillingTypeKeyEnum.PageKompetencerViewWidth:
      case BrugerIndstillingTypeKeyEnum.PageKompetencerViewOption:
      case BrugerIndstillingTypeKeyEnum.PageForloebsoverblikViewOption:
        const settingAsNumber = Number(settingValue);
        return !isNaN(settingAsNumber) ? settingAsNumber : undefined;
      case BrugerIndstillingTypeKeyEnum.PageForloebsoverblikUseAdvancedSearch:
      case BrugerIndstillingTypeKeyEnum.PageForloebsoverblikUseUdvidOverlap:
      case BrugerIndstillingTypeKeyEnum.PageForloebsoverblikUseHorizontalLines:
      case BrugerIndstillingTypeKeyEnum.PageForloebsoverblikUseUbesatteStillinger:
      case BrugerIndstillingTypeKeyEnum.PageForloebsoverblikUseForloebKladder:
      case BrugerIndstillingTypeKeyEnum.PageForloebsoverblikShowAnonymized:
        return settingValue.toLowerCase() === "true" ? true : settingValue.toLowerCase() === "false" ? false : undefined;
      case BrugerIndstillingTypeKeyEnum.PageForloebsoverblikShowInactive:
      case BrugerIndstillingTypeKeyEnum.PageUddannelseslaegerFilterForloebStatus:
        const settingParsed = JSON.parse(settingValue);
        return Array.isArray(settingParsed) ? settingParsed as number[] : undefined;
      case BrugerIndstillingTypeKeyEnum.LatestActiveUserRoleTitle:
          const loginEnumAsNumber = Number(settingValue);
          return !isNaN(loginEnumAsNumber) ? loginEnumAsNumber : undefined;
      default:
          return settingValue;
  }
}
